//GLOBAL - components from npm
import React from 'react';
import { Link } from 'react-router-dom';

import './button.css'

export default function Button({
    children,
    type = 'primary',
    icon,
    iconFulfill,
    link,
    onClick,
    disabled,
    className
}) {
    if (link) {
        return (
            <Link>
                <button className={`btn btn--${type} ${icon ? 'btn--icon' : ''} ${className && className}`} disabled={disabled}>
                    {icon && <div className={`icon icon--${iconFulfill}`}>{icon}</div>}
                    {children ? children : 'Button text'}
                </button>
            </Link>
        )
    } else if (onClick) {
        return (
            <button className={`btn btn--${type} ${icon ? 'btn--icon' : ''} ${className && className}`} onClick={onClick} disabled={disabled}>
                {icon && <div className={`icon icon--${iconFulfill}`}>{icon}</div>}
                {children ? children : 'Button text'}
            </button>
        )
    } else {
        return (
            <button className={`btn btn--${type} ${icon ? 'btn--icon' : ''} ${className && className}`} disabled={disabled}>
                {icon && <div className={`icon icon--${iconFulfill}`}>{icon}</div>}
                {children ? children : 'Button text'}
            </button>
        )
    }
}
